import {DmDocumentComponent} from "../../dm-document/dm-document.component";
import {Component} from "@angular/core";
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";

// NOT_IN_USE_CURRENTLY
@Component({
  selector: 'mvs-dm-document-consultant-component',
  templateUrl: './dm-document-consultant.component.html',
  styleUrls: ['./dm-document-consultant.component.scss'],
    standalone: false,
})
export class DmDocumentConsultantComponent extends DmDocumentComponent {

    ngOnInit() {
        super.ngOnInit();
    }

  onDocumentSelect(objectIdentifier: ObjectIdentifier) {
    console.log(objectIdentifier);
  }


























}
